import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useEffect, useState } from "react";
import LoadingOverlay from "./loader/LoadingOverlay";

const programsData = [
  {
    id: 1,
    image: require("../assets/images/primary2.jpg"),
    title: "PRIMARY WING (Classes I–V)",
    description: (
      <div>
        <p>
          Subjects: English • Hindi • Sanskrit • Mathematics • EVS • Science
          (from Class IV) • Social Science (from Class IV) • Computer Science •
          General Knowledge • Art & Craft • Dance • Physical Training • Yoga
        </p>
      </div>
    ),
  },
  {
    id: 2,
    image: require("../assets/images/a8.jpg"),
    title: "MIDDLE WING (Classes VI–VIII)",
    description: (
      <div>
        <p>
          Subjects: English • Hindi • Sanskrit • Mathematics • Social Science •
          Computer Science • General Knowledge • Painting • Health & Physical
          Education • Yoga
        </p>
      </div>
    ),
  },
  {
    id: 3,
    image: require("../assets/images/a7.jpg"),
    title: "SENIOR WING (Classes IX & X)",
    description: (
      <div>
        <p>
          Subjects: English • Hindi • Sanskrit • Mathematics • Science • Social
          Science • Computer Science • General Knowledge • Art Education •
          Health & Physical Education • Yoga
        </p>
      </div>
    ),
  },
  {
    id: 4,
    image: require("../assets/images/st8.jpg"),
    title: "SENIOR SECONDARY (Classes XI–XII)",
    description: (
      <div>
        <p>Streams: Humanities • Commerce • Science</p>
        <p>
          Subjects include: English • Political Science / Chemistry • History /
          Physics • Mathematics / Biology / Physical Education
        </p>
      </div>
    ),
  },
  {
    id: 5,
    image: require("../assets/images/sport3.jpg"),
    title: "Sports & Yoga",
    description: (
      <div>
        <p>
          Activities: Cricket • Football • Basketball • Badminton • Volleyball •
          Taekwondo • Table Tennis • Chess • Carrom • Gymnastics
        </p>
        <p>
          Guided Yoga sessions promote self-awareness, focus, and well-being
          under certified instructors.
        </p>
      </div>
    ),
  },
  {
    id: 6,
    image: require("../assets/images/a4.jpg"),
    title: "Art & Craft",
    description:
      "Students explore their imagination through creative projects using clay, fabric, paint, sand, and paper.",
  },
  {
    id: 7,
    image: require("../assets/images/a5.jpg"),
    title: "Music & Dramatics",
    description:
      "Students enhance self-expression through singing, acting, debates, elocution, and stage performances.",
  },
  {
    id: 8,
    image: require("../assets/images/a3.jpg"),
    title: "Olympiads & Academic Enrichment",
    description:
      "Competitive exams that challenge intellect, boost confidence, and prepare students for future academic success.",
  },
  {
    id: 9,
    image: require("../assets/images/skill2.jpg"),
    title: "Skill Development",
    description:
      "School academics focused on communication, leadership, digital literacy, and problem-solving for holistic growth.",
  },
];

function Appprograms() {
  const [headerLoading, setHeaderLoading] = useState(true);
  const [cardsLoading, setCardsLoading] = useState(() =>
    programsData.reduce((acc, item) => {
      acc[item.id] = true;
      return acc;
    }, {}),
  );

  // Preload background image manually
  useEffect(() => {
    const headerImg = new Image();
    headerImg.src = require("../assets/images/acad2.jpg");
    headerImg.onload = () => setHeaderLoading(false);
    headerImg.onerror = () => setHeaderLoading(false);
  }, []);

  const onCardImageLoad = (id) => {
    setCardsLoading((prev) => ({ ...prev, [id]: false }));
  };
  return (
    <section id="programs" className="block programs-block">
      <div className="programs-page">
        {/* HEADER */}
        <header className="position-relative">
          {headerLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LoadingOverlay overlayOnly />
            </div>
          )}

          <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
            <h1 className="text-center fw-semibold display-3">
              Academics & Activities
            </h1>
            <p className="text-center w-75 mb-5 fs-4">
              At Kanchan Vidya Mandir Sr. Sec. School, Our Academic Programs
              focus on academic excellence, creativity, and life skills. We
              blend core subjects with sports, arts, and technology to ensure
              the all-round development of every student.
            </p>
          </div>
        </header>

        {/* PROGRAM CARDS */}
        <Container fluid>
          <Row className="gx-4 gy-4">
            {programsData.map((program) => (
              <Col sm={4} key={program.id} className="d-flex">
                <div className="w-100 h-100 position-relative">
                  {cardsLoading[program.id] && (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(255,255,255,0.6)",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LoadingOverlay overlayOnly />
                    </div>
                  )}
                  <Card className="h-100 shadow-sm">
                    <Card.Img
                      variant="top"
                      src={program.image}
                      onLoad={() => onCardImageLoad(program.id)}
                      onError={() => onCardImageLoad(program.id)}
                    />
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="fw-bold fs-5 mb-0 p-3">
                        {program.title}
                      </Card.Title>
                      <div className="fs-8 p-3">{program.description}</div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default Appprograms;
